import { INeoAction } from './../Actions.interface';
import { IOrderline } from '../../Models/DTO/Orderline.models';
import { STATUS, REQUEST_ACTIONS } from '../../Constants/Actions.constants';

export interface CustomerProductsState {
  list: Record<string, IOrderline[]>;
  activeOrderlines: Record<string, IOrderline[]>;
  archivedOrderlines: Record<string, IOrderline[]>;
}

const INITIAL = {
  list: {},
  activeOrderlines: {},
  archivedOrderlines: {},
};

export default (
  state: CustomerProductsState = INITIAL,
  action: INeoAction,
): CustomerProductsState => {
  const { name, status, payload } = action;

  if (status === STATUS.SUCCESS) {
    if (name === REQUEST_ACTIONS.CUSTOMER_ACTIVE_ORDERLINES) {
      const customerId = payload[0].customerUUID;
      return {
        ...state,
        activeOrderlines: {
          ...state.activeOrderlines,
          [customerId]: payload,
        },
      };
    }

    if (name === REQUEST_ACTIONS.CUSTOMER_ARCHIVED_ORDERLINES) {
      const customerId = payload[0].customerUUID;
      return {
        ...state,
        archivedOrderlines: {
          ...state.archivedOrderlines,
          [customerId]: payload,
        },
      };
    }

    if (name === REQUEST_ACTIONS.CUSTOMER_EVENT_ORDERLINES) {
      if (payload.length === 0) return state;

      const customerId = payload[0].customerUUID;
      return {
        ...state,
        list: {
          ...state.list,
          [customerId]: payload,
        },
      };
    }
  }

  return state;
};
